import { Form, FormFieldType } from "@/forms/Form";

export class DocumentForm extends Form {
  protected definition = {
    name: { type: FormFieldType.Text, required: true },
    file: { type: FormFieldType.File, required: true },
    description: { type: FormFieldType.Text, required: false }
  };
}
